import { ColDef, DoesFilterPassParams } from 'ag-grid-community';
import {
  createDateCol,
  dateComparator,
  formatDateMMYY,
} from '~/components/agGrid/columns/dateColumns';
import { createValidCol } from '~/components/agGrid/columns/sharedColumns';
import { CustomSetFilter } from '~/components/agGrid/filters/CustomSetFilter';
import { BoardCertFormValues } from './types';
import { getBoardCertActiveStatus } from './utils';

export const boardCertColumns = (): ColDef<BoardCertFormValues>[] => {
  return [
    createValidCol(),
    {
      headerName: 'Certification',
      valueGetter: ({ data }) => data?.certName || '',
      filter: {
        component: CustomSetFilter,
        doesFilterPass: ({ model, node }: DoesFilterPassParams) => {
          if (!model || model.length === 0) return true;
          return node.data?.certName && model.includes(node.data.certName);
        },
      },
      comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB),
    },
    {
      field: '_tblBoardName',
      headerName: 'Board Name',
    },
    {
      headerName: 'Certification Date',
      filter: 'agDateColumnFilter',
      valueFormatter: formatDateMMYY,
      valueGetter: ({ data }) => {
        if (data) {
          const date = data?.recertDate ? data.recertDate : data?.origCertDate;
          return new Date(date);
        }
      },
      comparator: dateComparator,
    },
    createDateCol('expiryDate', 'Expiration Date'),
    {
      colId: 'active',
      headerName: 'Active',
      valueGetter: ({ data }) => {
        if (!data || !data.status) return 'Unknown';
        return getBoardCertActiveStatus(data.expiryDate, data.status.label);
      },
      filter: {
        component: CustomSetFilter,
        doesFilterPass: ({ model, node }: DoesFilterPassParams) => {
          if (!model || model.length === 0) return true;
          const value = node.data?.status
            ? getBoardCertActiveStatus(node.data.expiryDate, node.data.status.label)
            : 'Unknown';
          return model.includes(value);
        },
      },
      comparator: (valueA: string, valueB: string) => valueA.localeCompare(valueB),
    },
  ];
};

export const ACTIVE_STATUSES = ['Lifetime Certification'];
export const TIME_SENSITIVE_STATUSES = [
  'Time-Limited Certification',
  'Certified and Actively Maintained',
  'Certified Not Actively Maintained',
];
export const INACTIVE_STATUSES = ['Inactive', 'No Longer Certified'];

export const STATUSES = [...ACTIVE_STATUSES, ...TIME_SENSITIVE_STATUSES, ...INACTIVE_STATUSES];

export const STATUS_OPTIONS = STATUSES.map((status) => ({ label: status, value: status }));

export const TYPE_OPTIONS = ['Specialty', 'Subspecialty'].map((type) => ({
  label: type,
  value: type.toUpperCase(),
}));

export const emptyBoardCertForm: BoardCertFormValues = {
  certName: '',
  certNum: '',
  certType: TYPE_OPTIONS[0],
  expiryDate: '',
  id: undefined,
  origCertDate: '',
  medicalBoard: undefined,
  mocReqFlag: false,
  specialtyBoard: undefined,
  specialty: undefined,
  subSpecialtyCertificate: undefined,
  status: STATUS_OPTIONS[0],
};
